import { Editor } from '@/editor';

export function useEditor() {
  const editor = Editor.getSingleton();

  return editor;
}

export function useEditorContainer() {
  return Editor.getSingleton().sceneContainer;
}
